import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiResponse } from '../classes/api-response';
import { environment } from '../../environments/environment';
import { map } from 'rxjs/operators';
import { Company } from '../model/company';
import { HttpClient } from '@angular/common/http';
import { Constants } from "../utils/constants";

@Injectable({
  providedIn: 'root'
})
export class CompaniesService {

  private readonly entities = Constants.entities;
  private readonly crtlPathFragment = this.entities.companies;
  private readonly crtlFullPath = `${environment.apiUrl}/${this.crtlPathFragment}`;

  constructor(private http: HttpClient) {
  }

  public getAllCompanies(): Observable<Company[]> {
    return this.http
      .get<ApiResponse>(`${this.crtlFullPath}`)
      .pipe(map(value => value.data as Company[]));
  }

  public getCompanyById(companyId?: number | string): Observable<Company> {
    return this.http
      .get<ApiResponse>(`${this.crtlFullPath}/${companyId}`)
      .pipe(map(value => value.data as Company));
  }

  public createCompany(company: Company): Observable<Company> {
    return this.http
      .post<ApiResponse>(`${this.crtlFullPath}`, company)
      .pipe(map(value => value.data as Company));
  }

  public updateCompany(company: Company): Observable<void> {
    return this.http
      .patch<ApiResponse>(`${this.crtlFullPath}/${company.id}`, company)
      .pipe(map(() => { }));
  }

  public deleteCompany(id: number): Observable<void> {
    return this.http
      .delete<ApiResponse>(`${this.crtlFullPath}/${id}`)
      .pipe(map(() => { }));
  }

  public getExecutionList() {
    return this.http
      .get<ApiResponse>(`${this.crtlFullPath}/exec-list`)
  }

  public getSubmissionInformation(comid: number) {
    return this.http
      .get<ApiResponse>(`${environment.apiUrl}/v1/company/${comid}/submission-information`)
  }

  public getTestImages(comid: number, page_num?: number, page_size?: number) {

    page_num = page_num || 1;
    page_size = page_size || 15;

    return this.http
      .get<ApiResponse>(`${environment.apiUrl}/v1/company/${comid}/submitted-testlist?page_num=${page_num}&page_size=${page_size}`)
  }

  public addTestImage(comid: number, data) {
    return this.http
    .post<ApiResponse>(`${environment.apiUrl}/v1/company/${comid}/submit-test-information`, data)
  }

  public getUploadSignedUrl(comid: number, filename: string, size: number): Observable<any> {
    return this.http
      .get<ApiResponse>(`${environment.apiUrl}/${this.entities.company}/${comid}/${this.entities.image_files}/${this.entities.uploadSignedUrl}?filename=${filename}&byteLength=${size}`);
  }

  public uploadFile(arrayBuffer: ArrayBuffer, filename: string, fileType: string, url: string, fields: { [key: string]: string }): Observable<any> {

    const formData = this.buildFormData(url, fields);

    formData.set("file", new Blob([arrayBuffer], { type: fileType }), filename);

    return this.http.post(
      url,
      formData,
      {
        reportProgress: true,
        observe: 'events'
      }
    );
  }

  buildFormData(url: string, fields: { [p: string]: string }): FormData {
    const formData = new FormData();

      for (const field in fields) {
        formData.set(field, fields[field]);
      }
    
    
    return formData;

  }

  public addDependeciesTestImage(comid: number, data: any) {

    return this.http.
      put<ApiResponse>(`${environment.apiUrl}/v1/${this.entities.company}/${comid}/add-dependencies`, data);

  }

  public deleteTestImageScriptDescriptors(comid: number, data: string) {
    return this.http
      .delete<ApiResponse>(`${environment.apiUrl}/v1/${this.entities.company}/${comid}/submitted-test/${data}`)
      .pipe(map(() => { }));;
  }
 

}
